module.exports = __webpack_public_path__ + "static/media/1.0bd3d1b0.jpg";